import {
  Grid, Button, Dialog, DialogActions, DialogContent,
  DialogContentText, DialogTitle, Typography, makeStyles,
} from "@material-ui/core";
import _, { isEmpty, isFunction } from 'lodash';
import { useContext, useEffect, useRef, useMemo, useState, useCallback } from 'react';
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from 'react-redux';

import QCXIIFormGroup from '../../../../../shared-components/ii-form-group/QCXIIFormGroup';
import InputWithCleanButton from '../../../../../components/declaracao-importacao/inputWithCleanButton/InputWithCleanButton'

import QCXFinalPercentualField from '../../../../../shared-components/final-percentual-field/QCXFinalPercentualField';

import { isValid, normalizeNumeral, normalizeYear, unnormalizeNumeral } from '../../../../../utils/general/general-utils';
import {
  formatBrazilianNumericDecimal,
  formatLINumber,
  formatNotZero,
} from '../../../../../utils/hooks/form/field/formatters';
import DeclaracaoImportacaoContext from '../../../../../contexts/import/declaracao-importacao/DeclaracaoImportacaoContext';
import { selectDeclaracaoImportacao, selectSubMode, selectRelatedAdicaoModel } from '../../../../../features/declaracao-importacao/declaracaoImportacaoSelectors';
import QCXFinalFormWizard from '../../../../../shared-components/final-form-wizard/QCXFinalFormWizard';
import QCXFormStepWizard from '../../../../../shared-components/form-step-wizard/QCXFormStepWizard';

import QCXCustomRegistrationTabControlTemplate from '../../../../../templates/custom-registration-one-to-many-page/QCXCustomRegistrationTabControlTemplate';

import {
  fetchAdicoesByDiDuimpIdAsync,
  fetchByIdFromFaturaAsync,
  fetchMercadoriasByFaturaIdAsync,
  updateAdicaoAsync,
  obterPlanilhaFundamentoLegalDuimp,
  obterPlanilhaTratamentoTributarioDuimp,
  importarTratamentosTributariosThunk,
  importarFundamentosLegaisThunk,
} from '../../../../../features/declaracao-importacao/declaracaoImportacaoThunks';

import {
  changeToSubConsultMode,
  failure,
  loading,
  resetBackgroundMode,
  resetRelatedAdicaoModel,
  setRelatedAdicaoModel,
  setResponse,
  success,
  resetSubMode,
  resetSubBackgroundMode,
  resetStatus,
} from '../../../../../features/declaracao-importacao/declaracaoImportacaoSlice';

import { setErrorFeedback, setSuccessFeedback } from '../../../../../features/feedback/feedbackSlice';

import { doGetQCXRequest, doPostQCXRequest, doPutQCXRequest } from '../../../../../utils/api/domain/domain-api-utils';

import { isNoneSubMode, isSubConsultMode, isSubCreateMode, isSubUpdateMode } from '../../../../../utils/store/store-utils';

import { BRAZILIAN } from '../../../../../utils/hooks/form/field/mask-types';

import {
  configureGeneralTipoDeclaracaoMatcherWith,
  TIPO_DECLARACAO_ADMISSAO_EM_ALC_AREA_DE_LIVRE_COMERCIO,
  TIPO_DECLARACAO_ADMISSAO_EM_DAD_DEPOSITO_ADUANEIRO_DE_DISTRIBUICAO,
  TIPO_DECLARACAO_ADMISSAO_EM_DE_DAF,
  TIPO_DECLARACAO_ADMISSAO_EM_EIZOF_ENTREPOSTO_INTERNACIONAL_DA_ZFM,
  TIPO_DECLARACAO_ADMISSAO_EM_ENTREPOSTO_ADUANEIRO,
  TIPO_DECLARACAO_ADMISSAO_EM_ENTREPOSTO_INDUSTRIAL,
  TIPO_DECLARACAO_ADMISSAO_EM_LOJA_FRANCA,
  TIPO_DECLARACAO_ADMISSAO_EM_ZPE_ZONA_DE_PROCESSAMENTO_DE_EXPORTACAO,
  TIPO_DECLARACAO_ADMISSAO_NA_ZFM_ZONA_FRANCA_DE_MANAUS,
  TIPO_DECLARACAO_ADMISSAO_TEMPORARIA,
  TIPO_DECLARACAO_CONSUMO_E_ADMISSAO_TEMPORARIA,
  TIPO_DECLARACAO_INTERNACAO_DA_ZFM_PE_PRODUTO_ESTRANGEIRO,
  TIPO_DECLARACAO_INTERNACAO_DA_ZFM_PI_PRODUTO_INDUSTRIALIZADO,
} from '../../../../../shared-components/select-tipo-declaracao/tipoDeclaracaoUtils';

import QCXFinalAlternativeCurrencyField from '../../../../../shared-components/final-currency-field/QCXFinalAlternativeCurrencyField';


import { selectTiposDeclaracao } from '../../../../../features/tipo-declaracao/tipoDeclaracaoSlice';

import {
  REGIME_TRIBUTACAO_ISENCAO_CODE,
  REGIME_TRIBUTACAO_REDUCAO_CODE,
  REGIME_TRIBUTACAO_SUSPENSAO_CODE,
  REGIME_TRIBUTACAO_IMUNIDADE_CODE,
  REGIME_TRIBUTACAO_RECOLHIMENTO_INTEGRAL_CODE,
  configureGeneralRegimeTributacaoMatcherWith,
} from '../../../../../shared-components/select-regime-tributacao/regimeTributacaoUtils';

import QCXSelectRegimeTributacaoAutocomplete from '../../../../../shared-components/select-regime-tributacao/QCXSelectRegimeTributacaoAutocomplete';

import QCXFormTitle from '../../../../../components/form-title/QCXFormTitle';

import { selectRegimesTributacao } from '../../../../../features/regime-tributacao/regimeTributacaoSlice';


const useStyles = makeStyles({
  paper: {
      maxWidth: '80%',
      width: 800,
      '@media (max-width: 900px)': {
          maxWidth: '100%',
          width: '100%',
      },
  },
  title: {
      borderBottom: '2px solid #000000',
  },
});


const AdicaoResumoFormStepWizard = ({ formPaginationControlProps={}, ...restProps }) => {

  const classes = useStyles();
  const { t } = useTranslation();
  
  const dispatch = useDispatch();

  const di = useSelector(selectDeclaracaoImportacao);
  const subMode = useSelector(selectSubMode);
  const adicao = useSelector(selectRelatedAdicaoModel) || {};
  const tiposDeclaracao = useSelector(selectTiposDeclaracao);
  const tipoDeclaracao = useMemo(() => di?.atributosAdicionais?.tipoDeclaracao?.id, [di]);
  const intl = BRAZILIAN;

  const {
    idDiSelecionada: idDuimp,
    unnormalize,
  } = useContext(DeclaracaoImportacaoContext);

  const hasFetchedMercadoriasRef = useRef(false);
  const [isLoadingAdicaoDetail, setIsLoadingAdicaoDetail] = useState(false);
  const adicoes = useMemo(() => di?.atributosAdicionais?.adicoes, [di]);

  const initialValues = useMemo(() => (adicao ? unnormalize(adicao) : {}), [adicao, unnormalize]);

  useEffect(() => {
    if (!adicoes?.length && !hasFetchedMercadoriasRef.current && idDuimp) {
      hasFetchedMercadoriasRef.current = true;
      dispatch(fetchAdicoesByDiDuimpIdAsync(idDuimp));
    }
  }, [idDuimp]);

  const fetchAdicaoDetail = useCallback(async ({ id }) => {
    if (!id) return;

    try {
      setIsLoadingAdicaoDetail(true);

      const response = await doGetQCXRequest(['diduimp', 'adicoes-detail', id]);

      dispatch(setRelatedAdicaoModel(response.data));
      dispatch(success());
    } catch (error) {
      dispatch(
        setErrorFeedback({
          message: 'Erro ao buscar adição.',
        })
      );
    } finally {
      setIsLoadingAdicaoDetail(false);
    }
  }, []);

  const currentTitleSubPage = useMemo(() => t('com.muralis.qcx.adicao.dadosAdicao'), []);

  const tableProps = useMemo(
    () => ({
      title: t('com.muralis.qcx.adicao.adicoesAdicionadas'),
      columns: [
        {
          field: 'nroAdicao',
          headerName: 'Ad',
          headerAlign: 'center',
          align: 'center',
          flex: 120,
          valueGetter: ({ row }) => row?.item || '-',
        },
        {
          field: 'quantidadeItens',
          headerName: 'Qt It',
          headerAlign: 'center',
          align: 'center',
          flex: 120,
          valueGetter: ({ row }) => row?.mercadorias?.length || '-',
        },
        {
          field: 'ncm',
          headerName: 'Ncm',
          headerAlign: 'center',
          align: 'center',
          flex: 160,
          valueGetter: ({ row }) => row?.ncm?.code || '-',
        },
        {
          field: 'numeroLi',
          headerName: 'Nro. LI',
          headerAlign: 'center',
          align: 'center',
          flex: 160,
          valueGetter: ({ row }) => row?.li?.registro || row?.mercadorias?.[0]?.numeroLI || '-',
        },
        {
          field: 'ii',
          headerName: 'II',
          headerAlign: 'center',
          align: 'center',
          flex: 140,
          valueFormatter: ({ row }) => unnormalizeNumeral(row?.ii?.aliquota, formatBrazilianNumericDecimal(2)) || '-',
        },
        {
          field: 'ipi',
          headerName: 'IPI',
          headerAlign: 'center',
          align: 'center',
          flex: 140,
          valueFormatter: ({ row }) => unnormalizeNumeral(row?.ipi?.aliquota, formatBrazilianNumericDecimal(2)) || '-',
        },
        {
          field: 'pis',
          headerName: 'PIS',
          headerAlign: 'center',
          align: 'center',
          flex: 140,
          valueFormatter: ({ row }) =>
            unnormalizeNumeral(row?.pisCofins?.aliquotaPisPasep, formatBrazilianNumericDecimal(2)) || '-',
        },
        {
          field: 'cofins',
          headerName: 'COFINS',
          headerAlign: 'center',
          align: 'center',
          flex: 160,
          valueFormatter: ({ row }) =>
            unnormalizeNumeral(row?.pisCofins?.aliquotaCofins, formatBrazilianNumericDecimal(2)) || '-',
        },
        {
          field: 'icms',
          headerName: 'ICMS',
          headerAlign: 'center',
          align: 'center',
          flex: 140,
          valueFormatter: ({ row }) => unnormalizeNumeral(row?.icms?.aliquota, formatBrazilianNumericDecimal(2)) || '-',
        },
        {
          field: 'aplicacaoMercadoria',
          headerName: 'Aplicação',
          headerAlign: 'center',
          align: 'center',
          flex: 200,
          valueFormatter: ({ row }) => row?.aplicacaoMercadoria || '-',
        },
      ],
    }),
    []
  );

  const internalControlButtonsPaginationProps = useMemo(
    () => ({
      paginationInfoField: {
        label: t('com.muralis.qcx.adicao.label'),
      },
      buttonGroup: {
        first: {
          description: t('com.muralis.qcx.adicao.primeiraAdicao'),
        },
        next: {
          description: t('com.muralis.qcx.adicao.proximaAdicao'),
        },
        previous: {
          description: t('com.muralis.qcx.adicao.adicaoAnterior'),
        },
        last: {
          description: t('com.muralis.qcx.adicao.ultimaAdicao'),
        },
      },
    }),
    [formPaginationControlProps]
  );

  const localeTableText = useMemo(
    () => ({
      noRowsLabel: t('com.muralis.qcx.validacao.nenhumaAdicaoEncontrada'),
    }),
    []
  );

  const handleChangeToSubNone = () => {
    dispatch(resetSubMode());
  };

  const handleLoadingStatus = useCallback(() => dispatch(loading()), []);

  const handleChangeToSubConsult = useCallback(() => {
    dispatch(resetSubBackgroundMode());
    dispatch(changeToSubConsultMode());
  }, []);

  const handleResetStatus = useCallback(() => dispatch(resetStatus()), []);
  
  const handleClearForm = useCallback(() => {
    dispatch(resetRelatedAdicaoModel());
  }, []);

  const isSubNone = useMemo(() => isNoneSubMode(subMode), [subMode]);

  const isSubCreate = useMemo(() => isSubCreateMode(subMode), [subMode]);

  const isSubConsult = useMemo(() => isSubConsultMode(subMode), [subMode]);

  const isSubUpdate = useMemo(() => isSubUpdateMode(subMode), [subMode]);


  const modes = useMemo(
    () => ({
      isSubConsult,
      isSubNone,
      isSubCreate,
      isSubUpdate,
    }),
    [isSubConsult, isSubNone]
  );

  const isSomeTipoDeclaracaoBy = useCallback(
    (codesToCompare) => configureGeneralTipoDeclaracaoMatcherWith(tiposDeclaracao)(tipoDeclaracao, codesToCompare),
    [tiposDeclaracao, tipoDeclaracao]
  );

  const configureRegimeTributacaoFilterPredicateWith = useCallback(() => {
    const regimeTributacaoFilters = (() => [
      REGIME_TRIBUTACAO_IMUNIDADE_CODE,
      REGIME_TRIBUTACAO_ISENCAO_CODE,
      REGIME_TRIBUTACAO_REDUCAO_CODE,
    ])();

    const regimeTributacaoFilterPredicate = (regime) => regimeTributacaoFilters.includes(regime?.code);

    return regimeTributacaoFilterPredicate;
  }, []);


  const regimeTributacao = useMemo(() => adicao?.ii?.regimeTributacao?.id, [adicao]);
  const regimesTributacao = useSelector(selectRegimesTributacao);


  const isSomeRegimeTributacaoBy = useCallback(
    (codesToCompare) =>
      configureGeneralRegimeTributacaoMatcherWith(regimesTributacao)(regimeTributacao, codesToCompare),
    [regimeTributacao, regimesTributacao]
  );


  return (
    <>
      <QCXFormStepWizard
        initialValues={initialValues}
        onSubmit={() => null}
        disableSubmitOnNext
        disablePristine
        controlComponentProps={{ isConsult: true, isLastStep: true, isLastRegistrationStep: true }}
        {...restProps}
      >
        {({ form, values, submitting, submitSucceeded }) => (
          <>
            <QCXCustomRegistrationTabControlTemplate
              initialValues={initialValues}
              title={currentTitleSubPage}
              tableProps={tableProps}
              tableData={adicoes}
              handleEdit={() => null}
              handleChangeModel={fetchAdicaoDetail}
              controlButtonsPaginationProps={internalControlButtonsPaginationProps}
              buttonGroupOptions={{}}
              hiddenNewButton
              isConsult
              disableUpdate
              autoControlInitialValues
              localeTableText={localeTableText}
              handleChangeToSubNone={handleChangeToSubNone}
              handleLoadingStatus={handleLoadingStatus}
              handleChangeToSubConsult={handleChangeToSubConsult}
              handleResetStatus={handleResetStatus}
              handleClearForm={handleClearForm}
            >
              {/* calculos adicao */}
              {() => (
                  <>

                    {/* DADOS ADICAO */}
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <QCXFormTitle title="Dados adição atual" />
                    </Grid>

                    {/* DESCRICAO/MOEDA */}
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <QCXFormTitle title="MERCADORIA" />
                    </Grid>

                    <Grid item xs={4}>
                        <QCXFinalAlternativeCurrencyField
                          id="currency-valor-despesas-moeda-field"
                          key="currency-valor-despesas-moeda-field"
                          name="valorDespesaMoeda"
                          label="Valor das Despesas na Moeda"
                          disabled
                          submitSucceeded={submitSucceeded}
                          scale={7}
                        />
                    </Grid>

                    <Grid item xs={4}>
                      <QCXFinalAlternativeCurrencyField
                        id="currency-valor-despesas-field"
                        key="currency-valor-despesas-field"
                        name="valorDespesaReal"
                        label="Valor das Despesas em Reais"
                        disabled
                        submitSucceeded={submitSucceeded}
                        scale={7}
                      />
                    </Grid>


                    <Grid item xs={4}>
                      <QCXFinalAlternativeCurrencyField
                        id="currency-valor-condicao-venda-field"
                        key="currency-valor-condicao-venda-field"
                        name="valorFreteMoeda"
                        label={t('com.muralis.qcx.frete.valorTotalFreteInternacional')}
                        disabled
                        submitSucceeded={submitSucceeded}
                        scale={7}
                      />
                    </Grid>

                    <Grid item xs={4}>
                      <QCXFinalAlternativeCurrencyField
                        id="currency-valor-condicao-venda-field"
                        key="currency-valor-condicao-venda-field"
                        name="valorFreteReal"
                        label="Valor Frete Internacional em Reais"
                        disabled
                        submitSucceeded={submitSucceeded}
                        scale={7}
                      />
                    </Grid>

                    <Grid item xs={4}>
                      <QCXFinalAlternativeCurrencyField
                        id="currency-valor-seguro-internacional-field"
                        key="currency-valor-seguro-internacional-field"
                        name="valorSeguroMoeda"
                        label="Valor Seguro na Moeda"
                        disabled
                        submitSucceeded={submitSucceeded}
                        scale={7}
                      />
                    </Grid>

                    <Grid item xs={4}>
                      <QCXFinalAlternativeCurrencyField
                        id="currency-valor-seguro-internacional-field"
                        key="currency-valor-seguro-internacional-field"
                        name="valorSeguroReal"
                        label="Valor Seguro Internacional em Reais"
                        disabled
                        submitSucceeded={submitSucceeded}
                        scale={7}
                      />
                    </Grid>
                    

                    {/* AFRMM */}
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <QCXFormTitle title="AFRMM" />
                    </Grid>

                    <Grid item container xs={12} sm={6} md={6} lg={6}>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <QCXFinalAlternativeCurrencyField
                          id="valor-devido-reais-field-icms"
                          key="valor-devido-reais-field-icms"
                          name="afrmm.valorDevidoReal"
                          label={t('com.muralis.qcx.valorDevidoReais')}
                          disabled
                          adorned
                        />
                      </Grid>
                    </Grid>

                    {/* IMPOSTOS II */}

                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <QCXFormTitle title={t('com.muralis.qcx.imposto.II')} />
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <InputWithCleanButton>
                        <QCXSelectRegimeTributacaoAutocomplete
                          id="select-field-regime-tributacao-ii"
                          key="select-field-regime-tributacao-ii"
                          name="ii.regimeTributacao.id"
                          label={t('com.muralis.qcx.regimeTributacao')}
                          disabled
                          initialValues={values}
                          configureFilterPredicate={
                            isSomeTipoDeclaracaoBy([
                              TIPO_DECLARACAO_INTERNACAO_DA_ZFM_PI_PRODUTO_INDUSTRIALIZADO,
                              TIPO_DECLARACAO_INTERNACAO_DA_ZFM_PE_PRODUTO_ESTRANGEIRO,
                            ]) && configureRegimeTributacaoFilterPredicateWith
                          }
                        />
                      </InputWithCleanButton>
                    </Grid>


                    <Grid item container xs={12} sm={6} md={6} lg={6}>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <InputWithCleanButton>
                          <QCXFinalPercentualField
                            id="aliquota-reduzida-acordo-tarifario-field-ii"
                            key="aliquota-reduzida-acordo-tarifario-field-ii"
                            name="ii.aliquotaReduzida"
                            label={t('com.muralis.qcx.aliquotaReduzida')}
                            disabled
                            scale={7}
                          />
                        </InputWithCleanButton>
                      </Grid>
                    </Grid>
                      
                    <Grid item container xs={12} sm={6} md={6} lg={6}>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <InputWithCleanButton>
                          <QCXFinalPercentualField
                            id="percentual-redução-acordo-tarifario-field-ii"
                            key="percentual-redução-acordo-tarifario-field-ii"
                            name="ii.percentualReducao"
                            label={t('com.muralis.qcx.percentualReducao')}
                            disabled
                            scale={7}
                          />
                        </InputWithCleanButton>
                      </Grid>
                    </Grid>


 
                  <Grid item container xs={12} sm={6} md={6} lg={6}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <InputWithCleanButton>
                        <QCXFinalPercentualField
                          id="aliquota-ad-valorem-acordo-tarifario-field-ii"
                          key="aliquota-ad-valorem-acordo-tarifario-field-ii"
                          name="ii.aliquota"
                          label={t('com.muralis.qcx.aliquotaADValorem')}
                          disabled
                        />
                      </InputWithCleanButton>
                    </Grid>
                  </Grid>       
                    

                  <Grid item container xs={12} sm={6} md={6} lg={6}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <InputWithCleanButton>
                        <QCXFinalPercentualField
                          id="aliquota-acordo-acordo-tarifario-field-ii"
                          key="aliquota-acordo-acordo-tarifario-field-ii"
                          name="ii.aliquotaAcordo"
                          label={t('com.muralis.qcx.aliquotaAcordo')}
                          disabled
                        />
                      </InputWithCleanButton>
                    </Grid>
                  </Grid>        
                  
                  <Grid item container xs={12} sm={6} md={6} lg={6}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <InputWithCleanButton>
                        <QCXFinalAlternativeCurrencyField
                          id="currency-valor-base-calculo-real-acordo-tarifario-field-ii"
                          key="currency-valor-base-calculo-real-acordo-tarifario-field-ii"
                          name="ii.baseCalculoReal"
                          label={t('com.muralis.qcx.baseCalculoReais')}
                          intl={intl}
                          disabled
                          submitSucceeded={submitSucceeded}
                          adorned
                          scale={7}
                        />
                      </InputWithCleanButton>
                    </Grid>
                  </Grid>

                  <Grid item container xs={12} sm={6} md={6} lg={6}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <InputWithCleanButton>
                        <QCXFinalAlternativeCurrencyField
                          id="valor-devido-reais-tarifario-field-ii"
                          key="valor-devido-reais-tarifario-field-ii"
                          name="ii.valorDevidoReal"
                          label={t('com.muralis.qcx.valorDevidoReais')}
                          disabled
                          adorned
                        />
                      </InputWithCleanButton>
                    </Grid>
                  </Grid>

                  <Grid item container xs={12} sm={6} md={6} lg={6}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <InputWithCleanButton>
                        <QCXFinalAlternativeCurrencyField
                          id="valor-recolher-reais-tarifario-field-ii"
                          key="valor-recolher-tarifario-field-ii"
                          name="ii.valorRecolherReal"
                          label={t('com.muralis.qcx.valorRecolherReais')}
                          disabled
                          adorned
                        />
                      </InputWithCleanButton>
                    </Grid>
                  </Grid>

                    {/* IMPOSTOS IPI */}

                    <Grid
                        item
                        style={{
                          paddingTop: '0px',
                        }}
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                      >
                      <QCXFormTitle
                        title={t('com.muralis.qcx.imposto.IPI')}
                        boxProps={{
                          pt: 0,
                        }}
                      />
                    </Grid>

                    <Grid item container xs={12} sm={6} md={6} lg={6}>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <InputWithCleanButton>
                          <QCXSelectRegimeTributacaoAutocomplete
                            id="select-field-regime-tributacao-ipi"
                            key="select-field-regime-tributacao-ipi"
                            name="ipi.regimeTributacao.id"
                            label={t('com.muralis.qcx.regimeTributacao')}
                            disabled
                            initialValues={values}
                          />
                        </InputWithCleanButton>
                      </Grid>
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6} className={classes.twin}>
                      <InputWithCleanButton>
                        <QCXFinalPercentualField
                          id="aliquota-reduzida-field-ipi"
                          key="aliquota-reduzida-field-ipi"
                          name="ipi.aliquotaReduzida"
                          label={t('com.muralis.qcx.reduzida')}
                          disabled
                          scale={7}
                        />
                      </InputWithCleanButton>
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <QCXFinalAlternativeCurrencyField
                        id="valor-devido-reais-tarifario-field-ipi"
                        key="valor-devido-reais-tarifario-field-ipi"
                        name="ipi.valorDevidoReal"
                        label={t('com.muralis.qcx.valorDevidoReais')}
                        disabled
                        adorned
                      />
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6} className={classes.gridFields}>
                      <InputWithCleanButton>
                        <QCXFinalPercentualField
                          id="aliquota-ad-valorem-field-ipi"
                          key="aliquota-ad-valorem-field-ipi"
                          name="ipi.aliquota"
                          label={t('com.muralis.qcx.ADValorem')}
                          disabled
                          scale={7}
                        />
                      </InputWithCleanButton>
                    </Grid>

                    <Grid item container xs={12} sm={6} md={6} lg={6}>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <QCXFinalAlternativeCurrencyField
                          id="currency-valor-base-calculo-real-field-ipi"
                          key="currency-valor-base-calculo-real-field-ipi"
                          name="ipi.baseCalculoReal"
                          label={t('com.muralis.qcx.baseCalculoReais')}
                          intl={intl}
                          disabled
                          submitSucceeded={submitSucceeded}
                          adorned
                          scale={7}
                        />
                      </Grid>
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <QCXFinalAlternativeCurrencyField
                        id="valor-recolher-reais-tarifario-field-ipi"
                        key="valor-recolher-reais-tarifario-field-ipi"
                        name="ipi.valorRecolherReal"
                        label={t('com.muralis.qcx.valorRecolherReais')}
                        disabled
                        adorned
                      />
                    </Grid>


                    {/* IMPOSTOS PIS/COFINS */}

                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <QCXFormTitle title={t('com.muralis.qcx.legislacao.PISCOFINS')} />
                    </Grid>

                    <Grid item container xs={12} sm={6} md={6} lg={6}>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <InputWithCleanButton>
                          <QCXFinalPercentualField
                            id="aliquota-ad-valorem-cofins-field"
                            key="aliquota-ad-valorem-cofins-field"
                            name="pisCofins.aliquotaCofins"
                            label={t('com.muralis.qcx.aliquotaADValorem')}
                            disabled
                            sclae={5}
                          />
                        </InputWithCleanButton>
                      </Grid>
                    </Grid>

                    <Grid item container xs={12} sm={6} md={6} lg={6}>
                      <Grid item xs={12} sm={12} md={12} lg={12} className={classes.gridFields}>
                        <InputWithCleanButton>
                          <QCXFinalPercentualField
                            id="percentual-redução-field"
                            key="percentual-redução-field"
                            name="pisCofins.percentualReducao"
                            label={t('com.muralis.qcx.percentualReducao')}
                            disabled
                            scale={7}
                          />
                        </InputWithCleanButton>
                      </Grid>
                    </Grid>


                    <Grid item xs={12} sm={6} md={6} lg={6} className={classes.gridFields}>
                      <InputWithCleanButton>
                        <QCXFinalPercentualField
                          id="percentual-redução-base-calculo-field"
                          key="percentual-redução-base-calculo-field"
                          name="pisCofins.percentualReducaoBaseCalculo"
                          label={t('com.muralis.qcx.percentualReducaoBaseCalculo')}
                          disabled
                          scale={7}
                        />
                      </InputWithCleanButton>
                    </Grid>

                    <Grid item container xs={12} sm={6} md={6} lg={6}>
                      <Grid item xs={12} sm={12} md={12} lg={12} className={classes.gridFields}>
                        <QCXFinalAlternativeCurrencyField
                          id="currency-valor-base-calculo-real-field"
                          key="currency-valor-base-calculo-real-field"
                          name="pisCofins.baseCalculoReal"
                          label={t('com.muralis.qcx.baseCalculoReais')}
                          intl={intl}
                          disabled
                          submitSucceeded={submitSucceeded}
                          adorned
                          scale={7}
                        />
                      </Grid>
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <QCXFinalAlternativeCurrencyField
                        id="valor-devido-reais-tarifario-field-pis"
                        key="valor-devido-reais-tarifario-field-pis"
                        name="pisCofins.valorDevidoPisPasepReal"
                        label={t('com.muralis.qcx.valorDevidoReais')}
                        disabled
                        adorned
                      />
                    </Grid>


                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <QCXFinalAlternativeCurrencyField
                        id="valor-recolher-reais-tarifario-field-pis"
                        key="valor-recolher-tarifario-field-pis"
                        name="pisCofins.valorRecolherPisPasepReal"
                        label={t('com.muralis.qcx.valorRecolherReais')}
                        disabled
                        adorned
                      />
                    </Grid>
                  </>
              )}

            </QCXCustomRegistrationTabControlTemplate>
          </>

        )}
      </QCXFormStepWizard>
    </>
  );
}


export default AdicaoResumoFormStepWizard;